import { HubUser } from '../types/generated/checklist-models';

export function orderViewersBySlot(
  viewers: readonly HubUser[],
  slotOf: (userId: string) => number | undefined
): HubUser[] {
  const rank = (viewer: HubUser): number =>
    slotOf(viewer.userId) ?? Number.MAX_SAFE_INTEGER;
  return [...viewers].sort((a, b) => rank(a) - rank(b));
}

export function viewerName(viewer: HubUser): string {
  return (
    viewer.displayName?.trim() || viewer.initials?.trim() || 'Unnamed user'
  );
}

export function viewerLabel(viewer: HubUser): string {
  const name = viewerName(viewer);
  const rank = viewer.rank?.name?.trim();
  return rank ? `${name} (${rank})` : name;
}

export function viewerInitials(viewer: HubUser): string {
  return (
    viewer.initials?.trim() ||
    viewer.displayName?.trim().slice(0, 2).toUpperCase() ||
    '?'
  );
}
